import { Badge, Btn } from "./UI";

const StatCard = ({ label, val, color }) => (
  <div style={{
    background: "#fff", borderRadius: 16, padding: "20px 22px",
    boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f1f5f9",
  }}>
    <div style={{ fontSize: 34, fontWeight: 800, color, lineHeight: 1 }}>{val ?? "—"}</div>
    <div style={{ fontSize: 12, color: "#64748b", fontWeight: 600, marginTop: 6 }}>{label}</div>
  </div>
);

const SectionTitle = ({ children }) => (
  <div style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 12 }}>
    {children}
  </div>
);

export default function Dashboard({ user, stats, jobs, onCreateJob, setTab, setSelectedJob }) {
  return (
    <div>
      {/* Greeting */}
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: "#0f172a", fontFamily: "'Playfair Display', serif", letterSpacing: "-0.5px" }}>
          Good day, {user?.name?.split(" ")[0] || "Agent"} 👋
        </h1>
        <p style={{ color: "#64748b", marginTop: 6, fontSize: 15 }}>
          Here's your hiring overview for today
        </p>
      </div>

      {stats ? (
        <>
          {/* Jobs stats */}
          <SectionTitle>Jobs Overview</SectionTitle>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(155px, 1fr))", gap: 14, marginBottom: 32 }}>
            <StatCard label="Total Jobs"   val={stats.jobs.total}       color="#6366f1" />
            <StatCard label="Approved"     val={stats.jobs.Approved}    color="#10b981" />
            <StatCard label="Pending"      val={stats.jobs.Pending}     color="#f59e0b" />
            <StatCard label="Closed"       val={stats.jobs.Closed}      color="#64748b" />
            <StatCard label="Total Hired"  val={stats.jobs.totalHired}  color="#8b5cf6" />
          </div>

          {/* Application stats */}
          <SectionTitle>Applications Overview</SectionTitle>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(155px, 1fr))", gap: 14, marginBottom: 36 }}>
            <StatCard label="Total Applications" val={stats.applications.total}       color="#6366f1" />
            <StatCard label="Pending Review"      val={stats.applications.Pending}     color="#f59e0b" />
            <StatCard label="Shortlisted"         val={stats.applications.Shortlisted} color="#3b82f6" />
            <StatCard label="Hired"               val={stats.applications.Hired}       color="#10b981" />
            <StatCard label="Rejected"            val={stats.applications.Rejected}    color="#ef4444" />
          </div>
        </>
      ) : (
        <div style={{ padding: "40px 0", textAlign: "center", color: "#94a3b8" }}>
          Loading stats…
        </div>
      )}

      {/* Recent jobs */}
      <div style={{
        background: "#fff", borderRadius: 20, padding: 24,
        boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f1f5f9",
      }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
          <h3 style={{ fontWeight: 700, color: "#0f172a", fontSize: 16 }}>Recent Jobs</h3>
          <Btn size="sm" onClick={onCreateJob}>+ Post Job</Btn>
        </div>

        {jobs.length === 0 ? (
          <div style={{ textAlign: "center", padding: "32px 0", color: "#94a3b8" }}>
            No jobs posted yet.
          </div>
        ) : (
          jobs.slice(0, 5).map(j => (
            <div key={j._id} style={{
              display: "flex", justifyContent: "space-between", alignItems: "center",
              padding: "12px 0", borderBottom: "1px solid #f1f5f9",
            }}>
              <div>
                <div style={{ fontWeight: 600, color: "#0f172a", fontSize: 14 }}>{j.title}</div>
                <div style={{ fontSize: 12, color: "#64748b", marginTop: 2 }}>
                  {j.company} · {j.city}
                  {j.totalApplicants > 0 && (
                    <button
                      onClick={() => { setSelectedJob(j); setTab("applicants"); }}
                      style={{
                        marginLeft: 10, background: "none", border: "none",
                        color: "#6366f1", cursor: "pointer", fontSize: 12, fontWeight: 600,
                        fontFamily: "'DM Sans', sans-serif",
                      }}
                    >
                      {j.totalApplicants} applicant{j.totalApplicants > 1 ? "s" : ""} →
                    </button>
                  )}
                </div>
              </div>
              <Badge status={j.status} />
            </div>
          ))
        )}
      </div>
    </div>
  );
}